import { render, staticRenderFns } from "./Camara.vue?vue&type=template&id=517c5284&scoped=true&"
import script from "./Camara.vue?vue&type=script&lang=js&"
export * from "./Camara.vue?vue&type=script&lang=js&"
import style0 from "./Camara.vue?vue&type=style&index=0&id=517c5284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c5284",
  null
  
)

export default component.exports